<template>
  <div>
    <base-header v-once></base-header>
    name : <input v-model="child.name" placeholder="새창.이름" /><br><br>
    data.id : <input v-model="child.data.id" placeholder="데이터.아이디" /><br><br>
    data.title : <input v-model="child.data.title" placeholder="데이터.제목" /><br><br>
    data.body : <input v-model="child.data.body" placeholder="데이터.본문" /><br><br>
    <button @click.enter="onCallParent">부모창으로 데이터 전송</button><br><br>

    <button @click="onNewPage()">새창열기(테스트)</button>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      child: {
        name: "pop-query-",
        data: {
          id: 0,
          title: '',
          body: ''
        }
      }
    };
  },
  watch: {
    '$store.state.ui.child'(child, old) {
      alert("child - changed");
      console.log('$store.state.ui.child.watch', child, old);
      this.child = this.$store.state.ui.child;
    }
  },
  methods: {
    onCallParent() {
      this.$utils.nativeIf.outbound.sendChildData(this.child);
      // this.$utils.nativeIf.outbound.close(false);
    },
    onNewPage: function() {
      this.$utils.nativeIf.outbound.newPage('/sample/detail');
    },
  },
};
</script>
